import { render, staticRenderFns } from "./search-keywords-form-id.vue?vue&type=template&id=0aa1375a&"
import script from "./search-keywords-form-id.vue?vue&type=script&lang=js&"
export * from "./search-keywords-form-id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports